/* 13.2-08: Verify's "Incidents to close" (Oversight). Quiet cards in the page's own palette: purple for identity,
   teal for "ready", amber for an open check, never red. */

.section {
  margin: 0 0 34px;
  max-width: 900px;
}

.sectionHead {
  display: flex;
  align-items: baseline;
  gap: 8px 16px;
  flex-wrap: wrap;
}

.sectionHead h2 {
  font-family: var(--serif);
  font-weight: 500;
  font-size: 22px;
  color: var(--purple-dark);
  margin: 0;
}

.count {
  margin-left: auto;
  font-size: 13.5px;
  color: var(--gray);
}

.count b {
  font-family: var(--serif);
  font-weight: 500;
  font-size: 20px;
  color: var(--charcoal);
  font-variant-numeric: tabular-nums;
}

.lede {
  margin: 4px 0 12px;
  font-size: 13.5px;
  color: var(--gray);
  max-width: 66ch;
}

.quietLine {
  margin: 0;
  font-size: 13.5px;
  color: var(--gray);
}

.clear {
  margin: 0;
  padding: 14px 16px;
  font-size: 13.5px;
  color: var(--gray);
  background: var(--white);
  border: 1px solid var(--line);
  border-radius: 14px;
}

.clear b {
  color: var(--teal-dark);
}

.problem {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin: 0 0 12px;
  padding: 12px 16px;
  font-size: 13.5px;
  color: var(--amber-dark);
  background: var(--amber-soft);
  border: 1px solid var(--amber-line);
  border-radius: 14px;
}

.problem p {
  margin: 0;
}

.retry {
  height: 30px;
  padding: 0 13px;
  font: inherit;
  font-size: 12.8px;
  font-weight: 600;
  color: var(--charcoal);
  background: var(--white);
  border: 1px solid var(--sage-dark);
  border-radius: 999px;
  cursor: pointer;
}

.retry[data-focus-visible] {
  outline: 2px solid var(--purple);
  outline-offset: 2px;
}

.cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px 18px;
  background: var(--white);
  border: 1px solid var(--line);
  border-radius: 14px;
  min-width: 0;
}

.cardHead {
  display: flex;
  align-items: baseline;
  gap: 6px 12px;
  flex-wrap: wrap;
}

.ref {
  font-weight: 700;
  font-size: 13.5px;
  color: var(--purple-dark);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.cardTitle {
  flex: 1 1 220px;
  min-width: 0;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.readyTag,
.openTag {
  flex: none;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 999px;
  white-space: nowrap;
}

.readyTag {
  color: var(--teal-dark);
  background: var(--teal-soft);
}

.openTag {
  color: var(--amber-dark);
  background: var(--amber-soft);
  border: 1px solid var(--amber-line);
}

.meta {
  margin: 0;
  font-size: 12.8px;
  color: var(--gray);
  overflow-wrap: anywhere;
}

.note {
  margin: 0;
  padding: 8px 12px;
  font-size: 13px;
  color: var(--charcoal);
  background: var(--lavender-light);
  border-radius: 10px;
}

.actions {
  display: flex;
  justify-content: flex-end;
}

.open {
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 16px;
  font-size: 13px;
  font-weight: 600;
  color: var(--charcoal);
  text-decoration: none;
  background: var(--white);
  border: 1px solid var(--sage-dark);
  border-radius: 999px;
}

.open:hover {
  border-color: var(--purple-light);
  color: var(--purple-dark);
}

.open:focus-visible {
  outline: 2px solid var(--purple);
  outline-offset: 2px;
}
